import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @module Client
 *
 * @description HTTP API Client
 */

/**
 * Default configuration
 */
export var defaults = {
  tls: true,
  api_key: "",
  baseUrl: "api.ideal-postcodes.co.uk",
  version: "v1",
  strictAuthorisation: false,
  timeout: 10000,
  header: {
    Accept: "application/json",
    "Content-Type": "application/json"
  },
  tags: [],
  agent: {}
};
/**
 * Client Class
 */

export var Client = /*#__PURE__*/function () {
  function Client(config) {
    _classCallCheck(this, Client);

    this.config = _objectSpread(_objectSpread({}, defaults), config);
    this.config.header = _objectSpread(_objectSpread({}, defaults.header), config.header && config.header);
  }
  /**
   * Return base URL for API requests
   */


  _createClass(Client, [{
    key: "url",
    value: function url() {
      var _this$config = this.config,
          baseUrl = _this$config.baseUrl,
          version = _this$config.version;
      return "".concat(this.protocol(), "://").concat(baseUrl, "/").concat(version);
    }
  }, {
    key: "protocol",
    value: function protocol() {
      return this.config.tls ? "https" : "http";
    }
  }]);

  return Client;
}();